<template>
    <div class="container">
        <div class="field">
          <div class="control has-icons-right">
            <label for="password" class="visually-hidden">{{ $t('password.newPassword') }}:</label>
            <input class="input" name="password" id="password" type="password" v-model.trim="password" :placeholder="$t('sectionProfile.enterPassword')" @keyup="check"/>
            <span class="icon is-small is-right">
              <span class="tag is-danger" v-if="score === 1">{{$t('sectionProfile.weak')}}</span>
              <span class="tag is-warning" v-if="score === 2">{{$t('sectionProfile.good')}}</span>
              <span class="tag is-success" v-if="score === 3">{{$t('sectionProfile.strong')}}</span>
            </span>
            <div class="strength">
              <div :class="{'weak': score >= 1}"></div>
              <div :class="{'good': score >= 2}"></div>
              <div :class="{'strong': score >= 3}"></div>
            </div>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <label for="confirm-password" class="visually-hidden">{{ $t('password.confirm') }}:</label>
            <input class="input" :class="{'is-danger': mismatch}" name="confirm-password" id="confirm-password" type="password" v-model.trim="confirm" :placeholder="$t('sectionProfile.confirmPassword')" @keyup="emitIfValid" />
          </div>
        </div>
        <div class="field" v-if="error">
          <div class="control" qa="save-button">
            <span :class="{'has-text-white': textIsWhite, 'help has-text-danger': !textIsWhite}">{{error}}</span>
          </div>
        </div>
    </div>
</template>

<script>
// import users from '@/api/users'
import throttle from 'lodash/throttle'
import PasswordStrength from '@fnando/password_strength'
import i18n from '@/i18n'

const minScore = 2

export default {
  props: ['textIsWhite', 'oldPassword'],
  data: function () {
    return {
      password: '',
      confirm: '',
      strength: ''
    }
  },
  computed: {
    score: function () {
      if (this.password.length === 0) {
        return 0
      }

      switch (this.strength) {
        case 'invalid':
          return 1
        case 'weak':
          return 1
        case 'good':
          return 2
        case 'strong':
          return 3
      }
    },
    mismatch: function () {
      return this.password.length > 0 && this.password !== this.confirm
    },
    tooWeak: function () {
      return this.password.length > 0 && this.score < minScore
    },
    error: function () {
      if (this.oldPassword && this.password === this.oldPassword) {
        return i18n.t('sectionProfile.passwordDifferent')
      } else if (this.tooWeak) {
        return i18n.t('sectionProfile.passwordWeak')
      } else if (this.mismatch) {
        return i18n.t('sectionProfile.passwordsDoNotMatch')
      }
    }
  },
  methods: {
    check: throttle(function () {
      if (this.password.length < 3) {
        this.strength = 'invalid'
        return
      }

      this.strength = PasswordStrength.test('', this.password).status
      this.emitIfValid()
    }, 250),
    emitIfValid: function () {
      if (this.score >= minScore && !this.error) {
        this.$emit('input', this.password)
      } else {
        this.$emit('input', '')
      }
    },
    clear: function () {
      this.password = ''
      this.confirm = ''
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .field {
    width: 100%;

    .icon {
      margin-right: 1rem;
    }
  }

  .strength {
    width: 100%;
    height: 0.25rem;
    padding: 0;
    display: flex;
    flex-direction: row;
    padding-top: 0.1rem;

    div {
      flex-grow: 1;
      background: #CCC;
      height: 0.25rem;
      margin: 0.1rem;

      &.weak {
        background: $danger;
      }

      &.good {
        background: $warning;
      }

      &.strong {
        background: $success;
      }
    }
  }
</style>
